import { render, staticRenderFns } from "./CrawlerManager.vue?vue&type=template&id=09dd5016&scoped=true"
import script from "./CrawlerManager.vue?vue&type=script&lang=js"
export * from "./CrawlerManager.vue?vue&type=script&lang=js"
import style0 from "./CrawlerManager.vue?vue&type=style&index=0&id=09dd5016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd5016",
  null
  
)

export default component.exports